import { styled } from "@mui/material/styles";

export const DisabledTooltipAnchor = styled("span")({
  height: "fit-content",
});
